import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import dashboard from "./slices/dashboard";
import grids from "./slices/grids";
import chart from "./slices/chart";
import metric from "./slices/metric";
import storylist from "./slices/storylist";
import brands from "./slices/admin/brands";
import referrers from "./slices/admin/referrers";
import referrerTypes from "./slices/admin/referrerTypes";
import sections from "./slices/admin/sections";
import tags from "./slices/admin/tags";
import conversions from "./slices/admin/conversions";
import notification from "./slices/admin/notification";
import dashboards from "./slices/admin/dashboards";
import bigscreenSettings from "./slices/admin/bigscreenSettings";
import goals from "./slices/admin/goals";
import goalConfiguration from "./slices/admin/goalConfiguration";
import goalArchive from "./slices/admin/goalArchive";
import goal from "./slices/goal";
import brandsettings from "./slices/brandsettings";
import videolist from "./slices/videolist";
import chartforecast from "./slices/chartforecast";
import notifications from "./slices/notifications";
import authenticateuser from "./slices/authenticateuser";
import user from "./slices/user"

const reducer = combineReducers({
	dashboard,
	grids,
	chart,
	chartforecast,
	metric,
	storylist,
	videolist,
	brands, 
	sections,
	referrers,
	referrerTypes,
	tags,
	conversions,
	notification,
	bigscreenSettings,
	dashboards,
	goals,
	goalConfiguration,
	goalArchive,
	goal,
	brandsettings,
	notifications,
	user,
	authenticateuser
});

const store = configureStore({
	reducer,
	middleware: [
		...getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}),
	],
});

export default store;
